import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IonRouterOutlet, ModalController, NavParams, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-super-like-txt-entry',
  templateUrl: './super-like-txt-entry.page.html',
  styleUrls: ['./super-like-txt-entry.page.scss'],
  providers:[IonRouterOutlet]
})
export class SuperLikeTxtEntryPage implements OnInit {

  public myForm: any;
  private msgControl : FormControl =  new FormControl('', Validators.maxLength(1000));
  public backButton: Subscription|any;
  public theSoul : any;
  public soulName : string;
  constructor(public modalCtrl:ModalController, 
    public navParams: NavParams,
    public platform: Platform,
    private analytics: AnalyticsService,) {

    this.theSoul = navParams.get('theSoul');
    this.soulName = this.theSoul.firstName != null? this.theSoul.firstName : '';

    this.myForm = new FormGroup({
      msgControl: this.msgControl
    });

  }

  ionViewWillEnter() {

    this.backButton = this.platform.backButton.subscribe(() => {
      this.dismiss();
    });

  }
  ionViewWillLeave() {
    if(this.backButton){
      this.backButton.unsubscribe();
    }
  
  }
  ngOnInit() {
  }

  getCharsLeft(){
    var maxChars : number = 1000;
    
    return maxChars - this.myForm.controls.msgControl.value.length;
  }

  getCharStatus(){
    /*switch(this.getCharsLeft()){
      case this.pageParameters.maxLength:
        return "full";
      
      case 0:
        return "empty";

      default:
        return "filling";  
        
    }*/

    if(this.getCharsLeft() >= 10){
      return " full";
      
    } else if (this.getCharsLeft() < 10 && this.getCharsLeft() > 0){
      return " filling";

    } else if (this.getCharsLeft() == 0){
      return " empty";
    
    } else {
      return " negative"
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SuperLikeTxtEntryPage'); 
  }

  dismiss(){
    document.getElementById("contentDiv")?.classList.add('animation');
    this.modalCtrl.dismiss('cancelled');
  }


  send(){
    this.modalCtrl.dismiss(this.myForm.controls['msgControl'].value);
    this.analytics.registerEvent(AnalyticsService.superLikeEvent);
    console.log('! Analytics "superLike" event sent !');
  }

  swipeEvent(e:any) {
    console.log('swiped');
    try {
      if(e == undefined || e == null || e.deltaX < 0) {
        // slide right
        return;
      }
      console.log(JSON.stringify(e));
      this.dismiss();
      
      // Check direction left to right
      // Check if works on other places this is opened
      // Can we have a better animation?
      //this.dismiss();
        
    } catch (error) {
      console.error(JSON.stringify(error), error);      
    }
  }

}
